// extracted by mini-css-extract-plugin
export default {"cls1":"InviteOTP-Strong_cls1__8xy4H","cls2":"InviteOTP-Strong_cls2__wr6BF InviteOTP-Strong_cls1__8xy4H"};